module.exports = __webpack_public_path__ + "static/media/work1.68aaed41.jpg";